// @flow
import { combineReducers } from "redux";
import * as actionTypes from "../constants/actionTypes";
import type { Action } from "../actions/auth";
import type { CombinedReducer } from "redux";

export type User = {
  token: string,
  userName: string,
  firstName: string,
  lastName: string,
  email: string,
  role: string
};

export type AuthState = {
  +from: ?string,
  +isFetching: boolean,
  +user: ?User,
  +hasError: boolean,
  +errorMessage: ?string,
  +forgotPasswordMessage: boolean
};

const isFetching = (state = false, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
    case actionTypes.LOGOUT:
    case actionTypes.RECOVER_PASSWORD:
      return true;

    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT_SUCCESS:
    case actionTypes.LOGOUT_ERROR:
    case actionTypes.RECOVER_PASSWORD_SUCCESS:
    case actionTypes.RECOVER_PASSWORD_ERROR:
      return false;

    default:
      return state;
  }
};

const hasError = (state = false, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGOUT:
    case actionTypes.LOGOUT_SUCCESS:
    case actionTypes.RECOVER_PASSWORD:
    case actionTypes.RECOVER_PASSWORD_SUCCESS:
      return false;

    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT_ERROR:
    case actionTypes.RECOVER_PASSWORD_ERROR:
      return true;

    default:
      return state;
  }
};

const errorMessage = (state = null, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGOUT_SUCCESS:
    case actionTypes.LOGOUT:
    case actionTypes.RECOVER_PASSWORD_SUCCESS:
    case actionTypes.RECOVER_PASSWORD:
      return null;

    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT_ERROR:
    case actionTypes.RECOVER_PASSWORD_ERROR:
      return action.payload.error;

    default:
      return state;
  }
};

const forgotPasswordMessage = (state = false, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT:
    case actionTypes.LOGOUT_SUCCESS:
    case actionTypes.LOGOUT_ERROR:
    case actionTypes.RECOVER_PASSWORD:
    case actionTypes.RECOVER_PASSWORD_ERROR:
      return false;

    case actionTypes.RECOVER_PASSWORD_SUCCESS:
      return true;

    default:
      return state;
  }
};

const user = (state = null, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      const { user } = action.payload;
      return user;

    case actionTypes.LOGOUT_SUCCESS:
      return null;

    default:
      return state;
  }
};

const from = (state = null, action: Action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      const { from } = action.payload;
      return from;

    case actionTypes.LOGOUT_SUCCESS:
      return null;

    default:
      return state;
  }
};

const auth: CombinedReducer<AuthState, Action> = combineReducers({
  from,
  isFetching,
  user,
  hasError,
  errorMessage,
  forgotPasswordMessage
});

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js